import React from 'react';
import './Services.css';

const Services = () => {
  const services = [
    {
      icon: '⬡',
      title: 'Cloud Services',
      description: 'Comprehensive AWS cloud solutions including architecture design, migration, and optimization. We help businesses scale efficiently in the cloud.',
      features: ['AWS Architecture', 'Cloud Migration', 'DevOps & CI/CD', 'Cost Optimization']
    },
    {
      icon: '◈',
      title: 'Machine Learning',
      description: 'Advanced ML model development using PyTorch and TensorFlow. From data preprocessing to model deployment and monitoring.',
      features: ['PyTorch Development', 'TensorFlow Models', 'Model Training', 'MLOps Pipeline']
    },
    {
      icon: '▦',
      title: 'Data Analysis',
      description: 'Large-scale data processing and feature analysis. Transform raw data into actionable insights for business growth.',
      features: ['Big Data Processing', 'Feature Engineering', 'Data Visualization', 'Predictive Analytics']
    },
    {
      icon: '◬',
      title: 'Custom Development',
      description: 'Tailored software solutions for your specific business needs. Full-stack development with modern technologies.',
      features: ['Web Applications', 'API Development', 'Database Design', 'System Integration']
    }
  ];

  return (
    <section id="services" className="services section">
      <div className="container">
        <h2 className="section-title">Our Services</h2>
        <p className="section-subtitle">
          We provide comprehensive software development services tailored to your business needs
        </p>
        
        <div className="services-grid">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">{service.icon}</div>
              <h3 className="service-title">{service.title}</h3>
              <p className="service-description">{service.description}</p>
              <ul className="service-features">
                {service.features.map((feature, featureIndex) => (
                  <li key={featureIndex}>{feature}</li>
                ))}
              </ul>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

export default Services;
